import { motion } from 'motion/react';
import styles from './PrevRecord.module.css';

export const PrevRecord = ({ prevRecord }) => {
  if (!prevRecord) {
    return null;
  }
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 2 }}
      className={styles.prevRecord}
    >
      <div className={styles.prevRecordTitle}>предыдущий рекорд</div>
      <div className={styles.prevRecordValue}>{prevRecord}</div>
    </motion.div>
  );
};
